import { X } from "lucide-react";
import { Button } from "../../primitives/button";

/**
 * The records a many-valued entity picker holds, each a chip with a Remove button: a command's many-valued entity
 * field and a many-valued list filter draw their picks the same way.
 */
export function ChosenEntities({
  label,
  chosen,
  nameOf,
  disabled = false,
  onRemove,
}: {
  /** The picker's name, for the list's accessible label. */
  label: string;
  chosen: readonly string[];
  /** The words for a chosen identifier: the name picked or found, else the identifier itself. */
  nameOf: (identifier: string) => string;
  disabled?: boolean;
  onRemove: (identifier: string) => void;
}) {
  if (chosen.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-1.5" aria-label={label}>
      {chosen.map((identifier) => (
        <li
          key={identifier}
          className="flex items-center gap-1 rounded-md border bg-muted px-2 py-0.5 text-sm"
        >
          {nameOf(identifier)}
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-5 w-5"
            disabled={disabled}
            aria-label={`Remove ${nameOf(identifier)}`}
            onClick={() => onRemove(identifier)}
          >
            <X className="h-3 w-3" />
          </Button>
        </li>
      ))}
    </ul>
  );
}
